<template>
  <div class="shop-manage">
    <div class="manage-wrapper">
      <div class="content">
        <div class="left-menu">
          <div class="menu-item">
            <div
              class="menu"
              @click="$router.push({ name: 'ShopHome', query: { uid } })"
            >
              <img src="../../../assets/images/icon-shop-manage.png" />
              店铺主页
            </div>
          </div>
          <div class="menu-item">
            <div class="menu">
              <img src="../../../assets/images/icon-shop-product.png" />
              商品管理
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="content-wrapper">
            <div class="title">
              <span>商品管理</span>
            </div>
            <div class="tool-wrapper">
              <div class="menu-box">
                <div
                  v-for="(item, index) in status_list"
                  :key="`st${index}`"
                  class="menu-item"
                  :class="[form_data.status == item.value ? 'active' : '']"
                  @click="form_data.status = item.value"
                >
                  {{ item.name }}({{ item.count }})
                </div>
              </div>
              <div class="search-box">
                <input
                  v-model="form_data.keyword"
                  type="text"
                  placeholder="输入关键词进行搜索商品"
                  @keyup.enter="onSearch"
                />
                <div class="search-btn" @click="onSearch">搜索</div>
              </div>
            </div>
            <div class="table-box">
              <div class="flex-table">
                <div class="flex-header-row">
                  <div class="col-check"></div>
                  <div class="col-info">商品信息</div>
                  <div class="col-time">上架时间</div>
                  <div class="col-action">操作</div>
                </div>
                <CheckboxGroup
                  v-model="checked_list"
                  @on-change="onCheckChange"
                >
                  <div
                    class="flex-row"
                    v-for="(item, index) in product_list"
                    :key="index"
                  >
                    <div class="col-check">
                      <Checkbox
                        :value="item.uuid"
                        :label="item.uuid"
                      ></Checkbox>
                    </div>
                    <div class="col-info">
                      <img :src="item.image" alt="" class="product-image" />
                      <div class="text-info">
                        <div class="product-name">{{ item.name }}</div>
                        <div class="category">
                          款式分类:{{ item.product_category_name }}
                        </div>
                        <div class="desc">款式说明:{{ item.description }}</div>
                      </div>
                    </div>
                    <div class="col-time">
                      {{ item.create_time }}
                    </div>
                    <div class="col-action">
                      <template
                        v-if="['0', '1'].includes(form_data.status.toString())"
                      >
                        <div
                          class="unsale-btn"
                          @click="switchSaleStatus(item.uuid)"
                        >
                          {{ form_data.status == 1 ? "下架" : "上架" }}
                        </div>
                        <div class="divider">|</div>
                      </template>
                      <div class="edit-btn" @click="edit(item.uuid)">编辑</div>
                      <template
                        v-if="['0', '-1'].includes(form_data.status.toString())"
                      >
                        <div class="divider">|</div>
                        <div class="delete-btn" @click="onDelete(item.uuid)">
                          {{ form_data.status === 0 ? "永久删除" : "删除" }}
                        </div>
                      </template>
                    </div>
                  </div>
                </CheckboxGroup>
              </div>
            </div>
            <div class="bottom-tool">
              <div class="batch-tool">
                <Checkbox
                  :indeterminate="indeterminate"
                  :value="checkAll"
                  @click.prevent.native="handleCheckAll"
                  >全选</Checkbox
                >
                <div v-if="form_data.status != -1"
                  class="batch-unsale"
                  @click="batchSwitchStatus(form_data.status)"
                >
                  {{ form_data.status == 1 ? "批量下架" : "批量上架" }}
                </div>
                <div class="batch-delete" @click="onDelete(checked_list, true)">
                  批量删除
                </div>
              </div>
              <div class="page-container">
                <Page
                  :total="total_count"
                  size="small"
                  prev-text="上一页"
                  next-text="下一页"
                  @on-change="onPageChange"
                ></Page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ProductCount,
  ProductDelete,
  ProductList,
  ProductOnsale,
  ProductUnsale
} from "@/api/index";
import { mapState } from "vuex";
export default {
  data() {
    return {
      uid: "",
      product_list: [],
      indeterminate: false,
      checkAll: false,
      checked_list: [],
      status_list: {
        onsale: { name: "展示中", value: 1, count: 0 },
        unauth: { name: "待审核", value: 2, count: 0 },
        unsale: { name: "已下架", value: 0, count: 0 },
        draft: { name: "草稿箱", value: -1, count: 0 },
      },
      form_data: {
        page: 1,
        limit: 15,
        status: '1',
        keyword: "",
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    total_count() {
      const { status } = this.form_data;
      switch (status.toString()) {
        case "0":
          return this.unsale_count;
        case "1":
          return this.onsale_count;
        case "-1":
          return this.draft_count;
        default:
          return 0
      }
    },
  },
  watch: {
    "form_data.status"(news, olds) {
      if (news != olds) {
        console.log("status change");
        this.getProductList();
      }
    },
  },
  mounted() {
    const { uid } = this.$route.query;
    console.log("uid", uid);
    if (!uid) {
      history.back();
      return;
    }
    this.uid = uid;
    this.getProductList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$emit("changeFooter", "original");
    });
  },
  methods: {
    onDelete(uuid, batch = false) {
      this.$DModal.confirm({
        content: "确认删除？",
        onOK: async () => {
          try {
            const param = {};
            param.uuid = batch ? uuid.join(",") : uuid;
            await ProductDelete(param);
            this.$layer.msg(`操作成功`)
            this.getProductList()
          } catch (e) {
            console.log("e", e);
          }
        },
      });
    },
    batchSwitchStatus(status) {
      switch (status.toString()) {
        case "0":
          this.onsale(this.checked_list, true);
          break;
        case "1":
          this.unsale(this.checked_list, true);
          break;
      }
    },
    async onsale(uuid, batch = false) {
      try {
        const param = {};
        batch ? (param.is_batch = true) : null;
        param.uuid = batch ? uuid.join(",") : uuid;
        const { msg } = await ProductOnsale(param);
        this.$layer.msg(msg);
        this.getProductList();
        this.checkAll = false;
        this.checked_list = [];
      } catch (e) {
        console.log("e-msg-onsale", e);
      }
    },
    async unsale(uuid, batch = false) {
      try {
        const param = {};
        batch ? (param.is_batch = true) : null;
        param.uuid = batch ? uuid.join(",") : uuid;
        const { msg } = await ProductUnsale(param);
        this.$layer.msg(msg);
        this.getProductList();
        this.checkAll = false;
        this.checked_list = [];
      } catch (e) {
        console.log("e-msg-unsale", e);
      }
    },

    switchSaleStatus(uuid) {
      const { status } = this.form_data;
      switch (status.toString()) {
        case "1":
          console.log("111");
          this.unsale(uuid);
          break;
        case "0":
          console.log("222");
          this.onsale(uuid);
          break;
      }
    },
    edit(uuid) {
      this.$router.push({ name: "ProductEdit", query: { uuid } });
    },
    onPageChange(e) {
      console.log("page_change", e);
      this.form_data.page = e;
      this.getProductList();
    },
    onCheckChange(data) {
      console.log("data", data);
      if (data.length === this.product_list.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    handleCheckAll() {
      console.log("checkaaa");
      // 半选(indeterminate)时 checkAll 已为 false，点击表头应“全选”，而非清空
      const willCheckAll = !this.checkAll;
      this.checkAll = willCheckAll;
      this.indeterminate = false;
      if (willCheckAll) {
        this.checked_list = this.product_list.map((item) => item.uuid);
        console.log("this.checked_list", this.checked_list);
      } else {
        this.checked_list = [];
      }
    },
    onSearch() {
      console.log("产品管理搜索");
      this.getProductList();
    },
    async onGetCount(){
      try{
        const {data} = await ProductCount(this.form_data);
        for(let code in data) {
          console.log('code',code);
          if(code != 'all'){
            this.status_list[code].count = data[code]
          }
        }
        console.log("data",data);
      }catch(e){
        console.log('e-count',e);
      }
    },
    async getProductList() {
      this.onGetCount();
      return ProductList({
        ...this.form_data,
        code: this.uid,
        // status: this.status,
      }).then((response) => {
        const { data } = response;
        this.product_list = data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./manage.scss";
</style>
